import { SET_USER } from "redux/actions/userActions";

const initialState = {
    token: null,
    data: null,
}

export function userReducer(state = initialState, action){
    switch(action?.type){
        case SET_USER:
            return {
                ...state,
                token: action?.token,
                data: action?.user,
            }
        default:
            return state;
    }    
}
